const locale = {
  placeholder: 'Velja tÃ­ma',
};

export default locale;
